import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, LoadLists } from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";

interface Parameter {
    productInfos?: Omit<ProductInfo, "productDetailPath">[];
    modalIsOpen: boolean;
}

type HandlerType = Handler<Parameter>;

// Create our custom handler with increased pageSize
export const GerrieLoadLists: HandlerType = props => {
    const state = props.getState();
    // GE-360: Get the original parameter but override the pageSize to 200
    const getWishListsParameter = {
        ...state.components.addToListModal.getWishListsParameter,
        pageSize: 200
    };
    const session = state.context.session;
    
    if (
        props.parameter.modalIsOpen &&
        (session.isAuthenticated || session.rememberMe) &&
        !getWishListsDataView(state, getWishListsParameter).value
    ) {
        props.dispatch(loadWishLists(getWishListsParameter));
    }
    
    props.dispatch({
        type: "Components/AddToListModal/UpdateGetWishListsParameter",
        parameter: {
            filter: "availableToAdd",
            pageSize: 200,
        }
    });
};

replaceInChain(chain, LoadLists, GerrieLoadLists); 